import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import $t from 'lib/trackingService';
import VideoEmbedIcon from './VideoEmbedIcon';

import styles from './styles.module.scss';

$t('register', 'mbt_navbar_socialShare');

const block = 'socialShareList';
let inputIdCounter = 0;

const track = (trackingID, platform) => {
  $t('track', trackingID, { platform });
};

const SocialShareList = (
  {
    enableMenu,
    twitterHref,
    facebookHref,
    emailHref,
    embedHref,
    smsHref,
    displayOptions,
    classes,
    tracking: trackingID = 'mbt_navbar_socialShare',
  },
) => {
  // Increment the counter to avoid input conflicts
  inputIdCounter += 1;

  const className = classNames(
    classes,
    block,
    styles.socialWrapper,
    {
      [styles.isKnockout]: displayOptions.isKnockout,
      [styles.useColoredIcons]: displayOptions.useColoredIcons,
      [styles.isFullWidthMobile]: displayOptions.isFullWidthMobile,
    },
    'dn-print',
  );

  return (
    <div className={className} data-test="social-share-list">
      <input
        className={classNames('dn', { [styles.socialMenuCheckbox]: enableMenu })}
        data-test="social-menu__checkbox"
        defaultChecked={enableMenu === false}
        id={`social-menu-toggle--${inputIdCounter}`}
        type="checkbox"
        tabIndex="-1"
      />

      <ul className={classNames(styles.socialList, 'js-social-share', { 'justify-between w-100 w-auto-m': displayOptions.isFullWidthMobile })}>
        <li className={classNames(styles.socialListText, 'founders-mono')}>
          { `${i18next.t('Share this')} -` }
        </li>

        <li className={styles.socialListIcon}>
          <a
            href={facebookHref}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => { track(trackingID, 'facebook'); }}
          >
            <span className={classNames('icon icon-facebook', styles.socialIcon)} />
          </a>
        </li>

        <li className={styles.socialListIcon} data-test="social-share-list__icon--twitter">
          <a
            href={twitterHref}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => { track(trackingID, 'twitter'); }}
          >
            <span className={classNames('icon icon-twitter', styles.socialIcon)} />
          </a>
        </li>

        {emailHref
          && (
          <li className={styles.socialListIcon} data-test="social-share-list__icon--email">
            <a href={emailHref} onClick={() => { track(trackingID, 'email'); }}>
              <span className={classNames('icon icon-email', styles.socialIcon)} />
            </a>
          </li>
          )}

        {smsHref
          && (
          <li className={classNames(styles.socialListIcon, 'db dn-m')} data-test="social-share-list__icon--sms">
            <a className="js-sms-link" href={smsHref} onClick={() => { track(trackingID, 'sms'); }}>
              <span className={classNames('icon icon-sms', styles.socialIcon)} />
            </a>
          </li>
          )}

        {embedHref
          && (
          <li className={classNames(styles.socialListIcon, 'dn db-m')} data-test="social-share-list__icon--embed">
            <VideoEmbedIcon
              href={embedHref}
              tracking={trackingID}
              classes={classNames('icon icon-embed', styles.socialIcon)}
            />
          </li>
          )}
      </ul>

      {/* eslint-disable jsx-a11y/label-has-for,jsx-a11y/label-has-associated-control */}
      {enableMenu
        && (
        <label className={styles.socialMenuExpand} data-test="social-share-list__icon--menu" htmlFor={`social-menu-toggle--${inputIdCounter}`}>
          <span className={styles.socialMenuDot} />
          <svg viewBox="0 0 20 20" className={styles.socialMenuClose}>
            <line x1="0" x2="20" y1="0" y2="20" className={styles.socialMenuCloseLine} />
            <line x1="0" x2="20" y1="20" y2="0" className={styles.socialMenuCloseLine} />
          </svg>
        </label>
        )}
      {/* eslint-enable jsx-a11y/label-has-for,jsx-a11y/label-has-associated-control */}
    </div>
  );
};

SocialShareList.propTypes = {
  enableMenu: PropTypes.bool,
  twitterHref: PropTypes.string.isRequired,
  facebookHref: PropTypes.string.isRequired,
  emailHref: PropTypes.string,
  embedHref: PropTypes.string,
  smsHref: PropTypes.string,
  classes: PropTypes.string,
  displayOptions: PropTypes.shape({
    useColoredIcons: PropTypes.bool,
    isKnockout: PropTypes.bool,
    isFullWidthMobile: PropTypes.bool,
  }),
  tracking: PropTypes.string,
};

SocialShareList.defaultProps = {
  enableMenu: false,
  emailHref: null,
  embedHref: null,
  smsHref: null,
  classes: null,
  displayOptions: {},
  tracking: undefined,
};

export default SocialShareList;
